module.exports = __webpack_public_path__ + "img/halo@2x.e982d27.jpg";